// TradingGrapes - Request to Purchase / Request Allocation Handler

(function () {

  // ─── CONFIG ───────────────────────────────────────────────
  const MAKE_WEBHOOK_URL = 'https://hook.eu1.make.com/r23pi70gvv37xwifvno6mjg3qq4cgrh4';
  // ──────────────────────────────────────────────────────────

  var overlay    = document.getElementById('tg-notify-overlay');
  var modal      = document.getElementById('tg-notify-modal');
  var closeBtn   = document.getElementById('tg-notify-close');
  var submitBtn  = document.getElementById('tg-notify-submit');
  var formWrap   = document.getElementById('tg-notify-form-wrap');
  var successEl  = document.getElementById('tg-notify-success');
  var errorEl    = document.getElementById('tg-notify-error');
  var titleEl    = document.getElementById('tg-modal-title');
  var subtitleEl = document.getElementById('tg-modal-subtitle');

  var currentButtonType  = '';
  var currentProductName = '';

  if (!overlay) return;

  // ── Open Modal ──────────────────────────────────────────
  function openModal(buttonType, productName) {
    currentButtonType  = buttonType;
    currentProductName = productName;

    formWrap.style.display  = 'block';
    successEl.style.display = 'none';
    errorEl.style.display   = 'none';
    document.getElementById('tg-email').value    = '';
    document.getElementById('tg-quantity').value = '';
    submitBtn.classList.remove('tg-disabled');

    if (buttonType === 'request-allocation') {
      subtitleEl.textContent = 'Allocation Wine Request';
      titleEl.textContent    = 'Request Allocation';
      submitBtn.textContent  = 'Request Allocation';
    } else {
      subtitleEl.textContent = 'Purchase Request';
      titleEl.textContent    = 'Request to Purchase';
      submitBtn.textContent  = 'Request to Purchase';
    }

    overlay.classList.add('tg-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      document.getElementById('tg-email').focus();
    }, 100);
  }

  // ── Close Modal ─────────────────────────────────────────
  function closeModal() {
    overlay.classList.remove('tg-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ── Close Button ────────────────────────────────────────
  closeBtn.onclick = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    closeModal();
    return false;
  };

  // ── Click Outside ────────────────────────────────────────
  overlay.onclick = function (e) {
    if (e.target === overlay) {
      e.stopImmediatePropagation();
      closeModal();
    }
  };

  // ── Escape Key ───────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('tg-open')) {
      closeModal();
    }
  });

  // ── Form Submit ─────────────────────────────────────────
  submitBtn.onclick = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var email    = document.getElementById('tg-email').value.trim();
    var quantity = document.getElementById('tg-quantity').value.trim();

    document.getElementById('tg-email').style.borderColor    = '';
    document.getElementById('tg-quantity').style.borderColor = '';

    if (!email || !validateEmail(email)) {
      document.getElementById('tg-email').style.borderColor = '#e05a5a';
      document.getElementById('tg-email').focus();
      return false;
    }
    if (!quantity || parseInt(quantity) < 1) {
      document.getElementById('tg-quantity').style.borderColor = '#e05a5a';
      document.getElementById('tg-quantity').focus();
      return false;
    }

    submitBtn.classList.add('tg-disabled');
    submitBtn.textContent = 'Submitting...';
    errorEl.style.display = 'none';

    var formData = new FormData();
    formData.append('email', email);
    formData.append('button_type', currentButtonType);
    formData.append('product_name', currentProductName);
    formData.append('bottle_quantity', quantity);

    fetch(MAKE_WEBHOOK_URL, {
      method: 'POST',
      body: formData
    })
    .then(function () {
      showSuccess();
    })
    .catch(function (err) {
      console.error('TradingGrapes notify error:', err);
      submitBtn.classList.remove('tg-disabled');
      submitBtn.textContent = currentButtonType === 'request-allocation' ? 'Request Allocation' : 'Request to Purchase';
      errorEl.style.display = 'block';
    });

    return false;
  };

  // ── Success ─────────────────────────────────────────────
  function showSuccess() {
    formWrap.style.display  = 'none';
    successEl.style.display = 'block';
    errorEl.style.display   = 'none';
  }

  // ── Validation ──────────────────────────────────────────
  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // ── Expose global open function ──────────────────────────
  window.tgNotifyOpen = openModal;

})();